import { createSignal } from "solid-js";
import { useNavigate } from "@solidjs/router";
import "./TestForm3.scss";

const TestForm3 = () => {
  const [email, setEmail] = createSignal("");
  const [firstName, setFirstName] = createSignal("");
  const [lastName, setLastName] = createSignal("");
  const [phoneNumber, setPhoneNumber] = createSignal("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    // navigate(`/lead_gen_page_3`);
    e.preventDefault();
    window.location.href = '/lead_gen_page_3';
  };

  return (
    <div className="TestForm3">
      <h1>Case 3: Conversion page has no email address</h1>
      <p>The conversion page from this form will not contain any email addresses.</p>
      <p>{"As a result, Auto PII will not pick up any email address."}</p>
      <p>Soft login will save the email entered in the form then send it with the conversion page ping.</p>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Email:</label>
          <input
            type="email"
            value={email()}
            onInput={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        {/* <div>
          <label>First Name:</label>
          <input
            type="text"
            value={firstName()}
            onInput={(e) => setFirstName(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Last Name:</label>
          <input
            type="text"
            value={lastName()}
            onInput={(e) => setLastName(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Phone Number:</label>
          <input
            type="tel"
            value={phoneNumber()}
            onInput={(e) => setPhoneNumber(e.target.value)}
            required
          />
        </div> */}
        <button type="submit">Submit</button>
      </form>
    </div>
  );
};
export default TestForm3;
